var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGoogleIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 23,
    viewBox: "0 0 22 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.6633 11.8403C21.6633 10.9484 21.5909 10.2976 21.4343 9.62268H11.25V13.6481H17.2279C17.1075 14.6485 16.4566 16.1551 15.0103 17.1674L14.99 17.3022L18.2101 19.7967L18.4332 19.819C20.4821 17.9267 21.6633 15.1426 21.6633 11.8403Z",
    fill: "#4285F4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.2487 22.4463C14.1774 22.4463 16.6361 21.4821 18.4319 19.8189L15.009 17.1673C14.0931 17.8061 12.8637 18.252 11.2487 18.252C8.38029 18.252 5.94572 16.3599 5.07787 13.7445L4.95066 13.7553L1.60238 16.3466L1.55859 16.4683C3.34233 20.0117 7.00626 22.4463 11.2487 22.4463Z",
    fill: "#34A853"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5.07862 13.7445C4.84963 13.0696 4.7171 12.3464 4.7171 11.5992C4.7171 10.8519 4.84963 10.1288 5.06657 9.45388L5.06051 9.31014L1.67027 6.67725L1.55934 6.73001C0.824182 8.20042 0.402344 9.85162 0.402344 11.5992C0.402344 13.3468 0.824182 14.9979 1.55934 16.4683L5.07862 13.7445Z",
    fill: "#FBBC05"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M11.2487 4.94628C13.2856 4.94628 14.6595 5.82609 15.4429 6.56134L18.5042 3.57233C16.6241 1.82474 14.1774 0.752075 11.2487 0.752075C7.00626 0.752075 3.34233 3.18664 1.55859 6.73001L5.06582 9.45388C5.94572 6.83852 8.38029 4.94628 11.2487 4.94628Z",
    fill: "#EB4335"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogleIcon);
export default __webpack_public_path__ + "static/media/google_icon.20a0e3cf6ab65d6bad13288b036134b6.svg";
export { ForwardRef as ReactComponent };